export enum SendUntilSelect {
  Low,
  Medium,
  High,
}
